// https://vuex.vuejs.org/en/state.html

export default {
  description: null,
  amount: null,
  distinationUser: null,
  transaction: {},
  sourceAccount: {},
  distinationTransaction: null,
};
